<template>
	<div class="mt-3 py-5">
		<b-container>

			<div class="content mb-auto">
				<div class="container-fluid sp-form-container">

					<!--Main layout-->
					<div class="container pl-3 pr-3">

						<nav class="pankuzu"><!--  style="display: none;" -->
							<ul class="my-4">
								<li><img class="" src="/static/img/icon/pankuzu.png" style="height: 17px;padding-bottom: 3px;"><a @click="jump(0)">  ピアチュウ TOP</a></li>
								<li><a @click="jump(1)">  企画記事・特集一覧</a></li>
								<li><a @click="jumpArticleList(article['id'])">  {{ article['title'] }}</a></li>
								<li>  {{ article_detail['title'] }}</li>
							</ul>
						</nav>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 px-0 mb-4">
								<img class="d-block mx-auto" :src="article['main_image']" alt="">
							</div>
							<div class="col-md-12 row">
								<div class="card col-md-9 my-3 pl-0 pr-0">

									<div class="card-body row p-2 pr-3">
										<div class="col-md-12">
											<div class="row pb-0 mb-0">
												<p class="card-text pb-0 mb-0 col-md-9">
													<span class="pull-left pt-0 mx-3" style="font-size: 1.2rem;"><strong>第{{ article_detail['article_details_index'] }}回 {{ article_detail['title'] }}</strong></span>
												</p>
												<p class="card-text pb-0 mb-0 col-md-3 text-right">
													<span class="pull-right">{{ date_only_format(article_detail['created_at']) }}</span>
												</p>
											</div>
											<hr class="my-1">
											<div class="pl-3 my-4">
												<p class="card-text" v-html="article_detail_contents">
												</p>
											</div>
										</div>
									</div>

								</div>

								<div class="col-md-3 my-3 px-3">
									<div class="kakomi-tape3">
										<span class="title-tape3">主要特集記事</span>
										<template v-for="(article, index) in allMainArticleLists">
											<div class="col-md-12  px-0 my-3" >
												<a style="padding-left: 1.5em;text-indent: -1.5em;" class="article-font-01 d-block" @click="jumpArticleList(article['id'])">
													<span style="display: inline">{{ index+1 }}. </span>
													<span style="display: inline">{{ article['title'] }}</span>
												</a>
											</div>
										</template>
									</div>
									<div class="kakomi-tape3" style="margin: 2.5em auto;">
										<span class="title-tape3">記事ランキング</span>
										<div class="mt-4">
											<template v-for="(article, index) in allArticleDetailLists">
												<div class="col-md-12  px-0 my-3" >
													<a style="padding-left: 1.5em;text-indent: -1.5em;" class="article-font-01 d-block" @click="jumpArticleDetail(article['id'])">
														<span style="display: inline">{{ index+1 }}. </span>
														<span style="display: inline">{{ article['title'] }}</span>
													</a>
												</div>
											</template>
										</div>
									</div>
									<div class="kakomi-tape3" style="margin: 2.5em auto;">
										<span class="title-tape3">最新の記事</span>
										<div class="mt-4">
											<template v-for="(article, index) in allNewArticleDetailLists">
												<div class="col-md-12  px-0 my-3" >
													<a style="padding-left: 1.5em;text-indent: -1.5em;" class="article-font-01 d-block" @click="jumpArticleDetail(article['id'])">
														<span style="display: inline">{{ index+1 }}. </span>
														<span style="display: inline">{{ article['title'] }}</span>
													</a>
												</div>
											</template>
										</div>
									</div>
							    </div>

							</div>
						</div>
    
					</div>
				</div>
			</div>

		</b-container>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import StarRating from 'vue-star-rating'

export default {
	name: 'ArticleDetail',
    components: {
	  'star-rating': StarRating,
    },
	data () {
		return {
            article: {
				title: null,
				main_image: null,
			},
			article_detail: {
				title: null,
				meta_title: null,
				meta_description: null,
			},

			article_detail_contents: null,

			main_article_lists: [],
			article_detail_lists: [],
			new_article_detail_lists: [],
		}
	},
	methods: {
	  jumpArticleDetail(id) {
		this.$router.push({path: '/article/detail/'+String(id)});
	  },
	  jumpArticleList(id) {
		this.$router.push({path: '/article/list/'+String(id)});
	  },
      jump(number) {
        if (number==0) {
          this.$router.push({path: '/'});
        } else if (number==1) {
          this.$router.push({path: '/article'});
		}
      },
	  async get_article() {
		this.$store.dispatch('article/get_article_detail_info', {
          article_details_id: this.$route.params.article_details_id
        }).then(res => {
		  console.log(res);
		  let ret = res.data.article_details;
		  this.article = ret['article'];
		  this.article_detail = ret['article_detail'];
		  if ( this.article_detail && this.article_detail.meta_title && String(this.article_detail.meta_title) != "" ) {
			document.title = String(this.article_detail.meta_title);
		  }
		  if ( this.article_detail && this.article_detail.meta_description && String(this.article_detail.meta_description) != "" ) {
		    document.querySelector('meta[name="description"]').setAttribute('content', String(this.article_detail.meta_description));
		  }
		  this.article_detail_contents = this.article_detail['contents'];
		  this.article_detail_contents = this.article_detail_contents.replace('[image_01]', this.article_detail['image_01']);
		  this.article_detail_contents = this.article_detail_contents.replace('[image_02]', this.article_detail['image_02']);
		  this.article_detail_contents = this.article_detail_contents.replace('[image_03]', this.article_detail['image_03']);
		  this.main_article_lists = ret['main_article_lists'];
		  this.article_detail_lists = ret['article_detail_lists'];
		  this.new_article_detail_lists = ret['new_article_detail_lists'];
		}, error => {
		  console.log('error発生');
		  console.log(error);
		  this.$nextTick(() => {
            window.scrollTo({
              top: 0,
            });
		  });
	    });
	  },
	},
	created() {
		this.get_article();
	},
	computed: {
	    allMainArticleLists: function() {
			return this.main_article_lists;
		},
	    allArticleDetailLists: function() {
			return this.article_detail_lists;
		},
	    allNewArticleDetailLists: function() {
			return this.new_article_detail_lists;
		},
	},
	watch: {
		$route (to, from) {
			if ( to.params.article_details_id != from.params.article_details_id ) {
				this.get_article();
			}
		}
	}
}
</script>

<style scoped>
.vue-star-rating {
	justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/ArticleDetail.vue